import {
  type AttributeInput,
  type SellingPlanAllocation,
} from '@shopify/hydrogen-react/storefront-api-types';
import dayjs from 'dayjs';

export const findSellingPlanAllocationByFrequency = ({
  sellingPlanAllocations,
  frequency,
}: {
  sellingPlanAllocations: SellingPlanAllocation[];
  frequency: '30 days' | '60 days' | '90 days';
}) => {
  return sellingPlanAllocations.find((allocation) => {
    const { options } = allocation.sellingPlan;
    const frequencyOption = options.find(
      (option) => option.name === 'Delivery every',
    );

    return frequencyOption?.value === frequency;
  });
};

export const orderGrooveTrialAttribute = {
  key: 'og_first_order_place_date',
  value: dayjs().add(30, 'days').format('YYYY-MM-DD'),
} satisfies AttributeInput;
